<template>
  <form autocomplete="off" @submit.prevent>
    <input
      type="text"
      v-show="!editModeActive"
      :value="bullets"
      @focus="activateEditMode"
      :placeholder="placeholder"
      :disabled="disabled"
    />
    <input
      name="disable-pwd-mgr-1"
      type="password"
      style="display: none;"
      value="disable-pwd-mgr-1"
    />
    <input
      name="disable-pwd-mgr-2"
      type="password"
      style="display: none;"
      value="disable-pwd-mgr-2"
    />
    <input
      name="disable-pwd-mgr-3"
      type="password"
      style="display: none;"
      value="disable-pwd-mgr-3"
    />
    <input
      type="password"
      autocomplete="off"
      v-show="editModeActive"
      :value="value"
      @input="$emit('input', $event.target.value)"
      ref="passwordInput"
      @blur="editModeActive = false"
    />
  </form>
</template>

<script>
export default {
  name: 'PasswordInput',
  props: ['value', 'disabled', 'placeholder'],
  computed: {
    bullets() {
      return this.value ? this.value.replace(/./g, '•') : ''
    }
  },
  data() {
    return {
      editModeActive: false
    }
  },
  methods: {
    activateEditMode() {
      this.editModeActive = true
      this.$nextTick(() => this.$refs.passwordInput.focus())
    }
  }
}
</script>

<style scoped></style>
